<div class="ols-form">
  <ul>
    <li *ngFor="let regel of vraag.vraagregels">{{regel}}</li>
  </ul>
  <div class="ols-form-wrapper">
    <div class="ols-message" *ngIf="prefilledMessage">{{prefilledMessage}}</div>

    <div *ngFor="let antw of vraag.antwoorden; let i = index" class="ols-form-group">
      <div [ngClass]='{ "has-focus": hasFocus(i), "has-success": hasValidValue(i), "has-error": !hasValidValue(i) && antw.hadFocus && !hasFocus(i), "is-empty": isLeeg(i), "ols-form-radio": isRadio(i) }'>
        <div class="ols-label">
          <div *ngIf="!isRadio(i)" class="ols-label-leading"></div>
          <label for="tb{{antw.id}}">{{antw.titel}}</label>
        </div>
        <ng-container *ngIf="!isRadio(i)">
          <input #answer type="text" name="tb{{antw.id}}" [(ngModel)]="antw.waarde" (click)="setSubmitClickedFalse(i)"
            (keyup)="formatValue(antw); notifyAntwoord()" (focus)='setFocus(i, true)' (blur)='setFocus(i, false)'>
          <p class="error-block"
            *ngIf="!hasValidValue(i) && !hasFocus(i) && (antw.hadFocus || submitClicked) && !isLeeg(i)">
            {{antw.foutmelding}}</p>
          <p class="error-block"
            *ngIf="!hasValidValue(i) && !hasFocus(i) && (antw.hadFocus || submitClicked) && isLeeg(i)">
            Vul alsjeblieft {{antw.stappenplan_kop | lowercase }} in</p>
        </ng-container>
        <ng-container *ngIf="isRadio(i)">
          <ul class="ols-radio">
            <li *ngFor="let optie of geefOpties(i)" (click)="antw.waarde = optie; notifyAntwoord()" #answer (click)="setSubmitClickedFalse(i)"
              [ngClass]="[antw.waarde == optie ? 'selected' : '']" [id]="geefMeetid(vraag, optie)">
              <div class="circle">
                <div class="outer">
                  <div class="inner"></div>
                </div>
              </div>
              <div class="ols-content">{{optie}}</div>
            </li>
          </ul>
          <p class="error-block" *ngIf="(submitClicked || antw.hadFocus) && (!antw.waarde || antw.waarde == '')">Maak alsjeblieft een keuze</p>
        </ng-container>
      </div>
    </div>
  </div>
</div>